'use client'
import { useEffect } from 'react'
import { useGetCurrentLanguage } from 'src/store/game'

export function LangDomManager() {
  const lang = useGetCurrentLanguage()

  useEffect(() => {
    // Update HTML lang attribute
    document.documentElement.lang = lang

    // Get existing classes from body
    const existingClasses = document.body.className.split(' ')

    // Remove any existing lang-* classes
    const cleanedClasses = existingClasses.filter((cls) => !cls.startsWith('lang-'))

    // Add new lang class while preserving other classes
    document.body.className = [...cleanedClasses, `lang-${lang}`].join(' ')
  }, [lang])

  return null
}
